<template>
  <div id="app">
    <ZHeader></ZHeader>
    <ZContent></ZContent>
    <ZFooter></ZFooter>
    <!-- <router-view /> -->
  </div>
</template>
<script>
import { ZHeader, ZFooter, ZContent } from "./components/index";
export default {
  data() {
    return {};
  },
  watch: {
    $route(to, from) {
      console.log("================", to, from);
    }
  },
  components: { ZHeader, ZFooter, ZContent },
  methods: {
    // 添加判断方法
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  mounted() {
    if (
      "-ms-scroll-limit" in document.documentElement.style &&
      "-ms-ime-align" in document.documentElement.style
    ) {
      window.addEventListener(
        "hashchange",
        () => {
          var currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false
      );
    }

    // if (this.isMobile) {
    //   window.location.href ="mindex.html"
    // } else {
    //   window.location.href ="index.html"
    // }
  }
};
</script>
<style lang="scss">
#app {
  max-width: 1920px;
  margin: 0 auto;
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: 400;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
